import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import AsyncSelect from "react-select/async";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";

const AddPortfolioTabData = ({ isSidebarOpen, formData, disable, error, onSetFormData, onSetError, handleSubmit, handleClose, from, id }) => {
    const [config] = useAuth();
    const [propertyOptions, setPropertyOptions] = useState([]);

    const loadPropertyOptions = async (inputValue = "") => {
        try {
            const dataToSend =
                from === "contact"
                    ? { contact_id: id, list_type: "contact", search: inputValue }
                    : { company_id: id, contact_id: formData.contactId, list_type: "company", search: inputValue };

            // convert object into query string
            const queryParams = new URLSearchParams(dataToSend).toString();

            const res = await axios.get(
                `${BASE_URL}/get-datalisting?list=properties&${queryParams}`,
                config
            );

            const data = res.data?.data?.properties || [];
            const mappedOptions = data.map((el) => ({
                value: el.id,
                label: (
                    <>
                        {el.property_name} <br /> {el.street_address}, {el.city}, {el.state}
                    </>
                ),
                fullProperty: {
                    id: el.id,
                    property_name: el.property_name,
                    street_address: el.street_address,
                    city: el.city,
                    state: el.state,
                },
            }));
            if (inputValue === "") {
                setPropertyOptions(mappedOptions);
            }
            return mappedOptions;
        } catch (err) {
            if (
                err.response?.data?.message &&
                err.response?.data?.message !== "Too Many Attempts."
            ) {
                NotificationManager.error(err.response?.data?.message);
            }
            return [];
        }
    };

    useEffect(() => {
        if (isSidebarOpen) {
            loadPropertyOptions();
        }
    }, [isSidebarOpen]);


    return (
        <form onSubmit={handleSubmit}>
            <div className="mt-6">
                <label className="dark-H head-4 mb-2">Property Name</label>
                <AsyncSelect
                    isMulti
                    cacheOptions
                    defaultOptions={propertyOptions}
                    loadOptions={loadPropertyOptions}
                    placeholder="Search Property Here"
                    className="mt-0 body-S rounded-[6px] dark-H"
                    value={
                        formData?.property
                            ? formData.property.map((p) => ({
                                value: p.id,
                                label: (
                                    <>
                                        {p.property_name} <br /> {p.street_address}, {p.city}, {p.state}
                                    </>
                                ),
                                fullProperty: p,
                            }))
                            : []
                    }
                    onChange={(options) => {
                        onSetFormData({
                            ...formData,
                            property: options
                                ? options.map((opt) => opt.fullProperty)
                                : [],
                        });
                    }}
                />
                {error?.property_name && (
                    <p className="body-S red-D pt-1">{error?.property_name}</p>
                )}
            </div>

            <div className="mt-6">
                <label className="dark-H head-4 mb-2">Name</label>
                <input
                    type="text"
                    placeholder="Write Name Here..."
                    className="mt-0 body-S rounded-[6px] dark-H"
                    value={formData.name}
                    onChange={(e) => {
                        onSetError({ ...error, name: "" });
                        onSetFormData({ ...formData, name: e.target.value });
                    }}
                />
            </div>

            <div className="mt-6">
                <label className="dark-H head-4 mb-2">Description</label>
                <input
                    type="text"
                    placeholder="Write note here..."
                    className="mt-0 body-S rounded-[6px] dark-H"
                    value={formData.description}
                    onChange={(e) => {
                        onSetError({ ...error, description: "" });
                        onSetFormData({ ...formData, description: e.target.value });
                    }}
                />
            </div>

            <div className="mt-6">
                <button type="submit" disabled={disable} className="save-button light-L head-5 green-bg-H">
                    Save
                </button>
                <button type="button" onClick={handleClose} className="green-H ml-5">
                    Cancel
                </button>
            </div>
        </form>
    );
};

export default AddPortfolioTabData;